// Shared constants and helpers for the batch (campaign) generation page.

export const sectionLabelSx = {
  fontSize: "0.6875rem",
  fontWeight: 700,
  letterSpacing: "0.08em",
  textTransform: "uppercase",
  color: "#0F172A",
  mb: 1,
};

export const panelSx = {
  borderRadius: "16px",
  border: "1px solid #E8ECF2",
  backgroundColor: "#fff",
};

export const TONE_OPTIONS = [
  { value: "formal", label: "Formal" },
  { value: "friendly", label: "Cercano" },
  { value: "technical", label: "Técnico" },
  { value: "casual", label: "Casual" },
  { value: "professional", label: "Profesional" },
  { value: "creative", label: "Creativo" },
];

export const LANGUAGE_TYPE_OPTIONS = [
  { value: "emotional", label: "Emocional" },
  { value: "rational", label: "Racional" },
  { value: "direct", label: "Directo" },
  { value: "inspirational", label: "Inspiracional" },
  { value: "narrative", label: "Narrativo" },
];

export const LANGUAGE_OPTIONS = [
  { value: "es", label: "Español" },
  { value: "en", label: "English" },
  { value: "ca", label: "Català" },
  { value: "fr", label: "Français" },
  { value: "pt", label: "Português" },
];

export const FREQUENCY_RANGE = { min: 1, max: 6 };
export const DURATION_RANGE = { min: 1, max: 4 };

export const optionLabel = (options, value) =>
  options.find((option) => option.value === value)?.label || value;

// Generation state of one piece of the batch, derived from the piece detail.
export const pieceState = (piece, adaptingIds) => {
  if (!piece) return "queued";
  if (piece.error_message && !piece.raw_content) return "error";
  if ((piece.platform_adaptations || []).length > 0) return "ready";
  if (!piece.raw_content) return "composing";
  if (adaptingIds.has(piece.id)) return "adapting";
  return "base";
};

export const STATE_CHIP = {
  ready: { label: "Listo", color: "done" },
  base: { label: "Texto base (prompt)", color: "info" },
  adapting: { label: "Adaptando...", color: "active" },
  composing: { label: "Componiendo...", color: "active" },
  queued: { label: "En cola", color: "muted" },
  error: { label: "Error", color: "blocked" },
};

export const estimatedMinutes = (pieces) => Math.max(1, Math.ceil(pieces / 4));
